import React, { useEffect, useState } from "react";
import {
    Typography, ListItemIcon, TextField, Box, Button, ListItem, List
} from "@material-ui/core";
import { DeleteOutline, EditOutlined, InsertDriveFile, FileCopyOutlined, VerticalAlignBottomOutlined, SwapHorizontalCircleOutlined } from '@material-ui/icons';
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from 'prop-types';
import { usePopupState, bindToggle } from 'material-ui-popup-state/hooks'
import icBlueAdd from '../assets/icons/icBlueAdd.png';
import icWhiteAdd from '../assets/icons/white-add.png';
import icArrowRight from '../assets/icons/icChevronRight.png';
import FolderImage from './iconFolder';
import classnames from 'classnames';
import FilePopover from './file-popover';
import CollapseImage from "./collapse-image";
import { baseAuthUrl } from '../authProvider';
import { useDataProvider, useTranslate } from 'react-admin';
import colors from '../CustomizedUIs/Colors';
import Checkbox from '../checkbox';
import { getTimeDayMonth, isImage, isVideo, isAudio, getFileNameWithoutExtension } from '../utils';
import { useDispatch } from 'react-redux';
import { changeItemSelectedPopup } from "../redux/actions/file-manager-actions";

var childItem = {
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "100px",
    fontFamily: "UniviaPro",
    fontWeight: 500,
    fontSize: 11,
    lineHeight: 1.2,
    fontStretch: "normal",
    fontStyle: "normal",
    letterSpacing: "normal",
}
var childItemName = {
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "300px",
    fontFamily: "UniviaPro",
    fontSize: 13,
    lineHeight: 1.25,
    letterSpacing: 0.13,
    color: '#4f5064',
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
}

const useStyles = makeStyles((theme) => ({
    iconPopover: {
        minWidth: 30,
    },
    underlineNotValue: {
        '&::before': {
            borderBottom: '1px solid' + colors.lightBlue['200']
        },
        '&:hover:not($disabled):before': {
            borderBottom: '1px solid' + colors.lightBlue['200']
        }
    },
    focuses: {
        backgroundColor: '#f3f7fa !important'
    },
    boxBoder: {
        borderBottom: '1px solid',
        borderRight: '1px solid',
        borderBottomColor: '#f3f7fa',
        borderRightColor: '#f3f7fa',
    },
    input: {
        backgroundColor: '#f3f7fa',
        borderRadius: '2px',
        "&:hover": {
            backgroundColor: '#f3f7fa'
        }
    },
    childItem,
    childItemName,
    titlePopover: {
        fontFamily: "UniviaPro",
        fontSize: "13px",
        fontWeight: "normal",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 1.25,
        letterSpacing: "0.13px",
    },
    btnOK: {
        fontFamily: "UniviaPro-Bold",
        fontSize: "11px",
        fontWeight: 'bold',
        fontStretch: "normal",
        fontStyle: 'normal',
        lineHeight: "normal",
        letterSpacing: " 0.44px",
        color: "#ffffff",
        padding: '12px 29px'
    },
}));

function CategoryItem({ item, classes, getCategory, onCheck, setSnackbarMessage, onDelete, pickerMode, permissions, setOpenSysPopupState, popupStateSysOpen }) {
    const dataProvider = useDataProvider();
    const translate = useTranslate();
    const classes2 = useStyles();
    const dispatch = useDispatch();

    const { name, type, size, timeSent, fd, id, parent, locked } = item;
    const isFolder = type === 'Folder';
    const popupState = usePopupState({ variant: 'popper', popupId: 'itemUploadTable' + item.id })
    const [showRename, setShowRename] = useState(false);
    const [expand, setExpand] = useState(false);
    const [textValue, setTextValue] = React.useState({
        name: getFileNameWithoutExtension(name),
    });
    const [validate, setValidate] = React.useState({
        name: {
            isError: true,
            message: ''
        },
    });

    const textOnChange = prop => (e) => {
        e.stopPropagation();
        setTextValue({
            ...textValue, [prop]: e.target.value
        });
        validateFc(prop, e.target.value)
    };

    const validateFc = (prop, value) => {
        if (prop === 'name') {
            if (value.length === 0)

                setValidate({
                    ...validate, [prop]: value.length === 0 ? {
                        isError: true, message: 'required'
                    } : {
                            isError: false, message: ''
                        }
                })
            else {
                const test = (/[*|\\:\/"<>?]/).test(value)
                setValidate({
                    ...validate, [prop]: test === true ? {
                        isError: true, message: translate(`pos.categories.errorFileName`)
                    } : {
                            isError: false, message: ''
                        }
                })
            }
        }
        else
            setValidate({
                ...validate, [prop]: value.length === 0 ? {
                    isError: true, message: 'required'
                } : {
                        isError: false, message: ''
                    }
            })

    }

    const handleOpen = () => {
        if (type === "Folder") {
            getCategory(item.id);
        } else {
            if (isImage(type) || isVideo(type) || isAudio(type)) {
                setExpand(!expand)
            } else if (!pickerMode) {
                window.open(`${baseAuthUrl}/category/download/${id}`);
            }
        }
    };

    const onCheckboxClick = e => {
        e.stopPropagation();
        onCheck(item.id);
    };

    const renderCategoryIcon = (id) => {
        if (isFolder) {
            return <FolderImage />;
        } else {
            if (isImage(type)) {
                return <img id={id} src={`${baseAuthUrl}/media/${fd}`} width="40" height="40" alt='' style={{ padding: 5 }} />
            } else {
                return <InsertDriveFile fontSize="large" />;
            }
        }
    };

    const onKeyDown = (e) => {
        if (!validate.name.message != "" && !validate.name.isError)
            if (e.key === 'Enter') {
                e.preventDefault();
                popupState.close();
                setShowRename(false);
                if (type === 'Folder')
                    onRename(id, textValue.name);
                else
                    onRename(id, textValue.name + "." + type);
            }
    };

    const downloadFile = () => {
        popupState.close();
        window.open(`${baseAuthUrl}/category/download/${id}`);
    };

    const downloadFolder = () => {
        let params = '?';
        params += 'ids=' + item.id + '&'
        window.open(`${baseAuthUrl}/category/multi-download/${params}`);
    };

    const onDeleteItemClick = () => {
        popupState.close();
        onDelete([item.id]);
    };

    const openSystemCategoryPopover = (event, type) => {
        setOpenSysPopupState(type);
        bindToggle(popupStateSysOpen).onClick(event);
    };

    const onRename = (id, name) => {
        dataProvider('UPDATE', 'category/rename', {
            id,
            data: {
                name: name,
                parentId: item.parent
            }
        }).then((data) => {
            getCategory(item.parent);
        }).catch(error => {
            if (error.message === 'pos.categories.existed') {
                setSnackbarMessage({
                    message: translate(`pos.categories.existed`),
                    boldText: ''
                });
            }
            if (error.message === 'pos.categories.existedFolder') {
                setSnackbarMessage({
                    message: translate(`pos.categories.existedFolder`),
                    boldText: ''
                });
            }
            else
                setSnackbarMessage({
                    message: translate(error.message),
                    boldText: ''
                });
            setTextValue({
                name: getFileNameWithoutExtension(item.name),
            })
            setShowRename(false)
        });
    };

    const onClick = () => {
        if (item.type === 'Folder') {
            getCategory(item.id);
        }
    };

    useEffect(() => {
        if (!popupState.isOpen) {
            setShowRename(false)
        }
        //refresh
        const ele = document.getElementById(fd);
        if (ele) {
            console.log('ele.src:', ele.src);
            // ele.style = 'border: 5px solid red';
            ele.src = ele.src;
        }
    }, [popupState, getCategory]);

    useEffect(() => {
        if (!showRename) {
            setTextValue({
                name: getFileNameWithoutExtension(name),
            })
        }
    }, [showRename]);

    return (
        <List style={{ paddingTop: 10, paddingBottom: 0 }} >
            <ListItem className={expand ? classnames(classes.root, classes.rootSelected) : classes.root} button onClick={handleOpen}>
                <Box flex={0.5} className={classes.childItem} px={1}>
                    {(permissions && !locked && pickerMode === 'menu' && permissions.isCreate) ? <Checkbox onClick={onCheckboxClick} checked={item.checked} />
                        : (!locked && pickerMode !== 'menu' && type !== "Folder" &&
                            <Checkbox onClick={onCheckboxClick} checked={item.checked} />
                        )
                    }
                </Box>
                <Box flex={1} className={classes.childItem}>
                    {renderCategoryIcon(fd)}
                </Box>
                <Box flex={6} className={classes.childItem} >
                    <Typography className={expand ? classnames(classes2.childItemName, classes.rootSelected) : classes2.childItemName} >{isFolder ? name : getFileNameWithoutExtension(name)}</Typography>
                </Box>
                <Box flex={2} className={classes.childItem}>
                    <Typography className={classes2.childItem} >{type}</Typography>
                </Box>
                <Box flex={2} className={classes.childItem}>
                    <Typography className={classes2.childItem}>{isFolder ? '' : `${Math.ceil(size / 1000000)}${translate('pos.common.mb')}`}</Typography>
                </Box>
                <Box flex={2} className={classes.childItem}>
                    <Typography className={classes2.childItem}>{getTimeDayMonth(timeSent, translate)}</Typography>
                </Box>
                <Box flex={1}></Box>
            </ListItem>
            {
                // (permissions && !locked && type !== "Folder" && permissions.isCreate) ?
                //     (
                //         pickerMode === 'menu' &&
                //         (
                //             popupState.isOpen ?
                //                 <Button className={classes.iconMenuContainerSelect} style={{ padding: 0, width: '25xp', height: '25px' }} {...bindToggle(popupState)}  >
                //                     <img alt='' src={icWhiteAdd} className={classes.iconMenu} />
                //                 </Button>
                //                 :
                //                 <Button className={classes.iconMenuContainer} style={{ padding: 0, width: '25xp', height: '25px' }} {...bindToggle(popupState)}>
                //                     <img alt='' src={icBlueAdd} className={classes.iconMenu} />
                //                 </Button>
                //         )
                //     ) : (type === "Folder" &&
                //         <Button style={{ padding: 7 }} className={classes.iconContainer} onClick={onClick}>
                //             <img alt='' src={icArrowRight} className={classes.icon} />
                //         </Button>
                //     )
                (permissions && !locked && permissions.isCreate) ?
                    (
                        pickerMode === 'menu' &&
                        (
                            popupState.isOpen ?
                                <Button className={classes.iconMenuContainerSelect} style={{ padding: 0, width: '25xp', height: '25px' }} {...bindToggle(popupState)}  >
                                    <img alt='' src={icWhiteAdd} className={classes.iconMenu} />
                                </Button>
                                :
                                <Button className={classes.iconMenuContainer} style={{ padding: 0, width: '25xp', height: '25px' }} {...bindToggle(popupState)}>
                                    <img alt='' src={icBlueAdd} className={classes.iconMenu} />
                                </Button>
                        )
                    ) : (
                        type === "Folder" &&
                        <Button style={{ padding: 7 }} className={classes.iconContainer} onClick={onClick}>
                            <img alt='' src={icArrowRight} className={classes.icon} />
                        </Button>
                    )
            }
            <FilePopover
                childrenPopup={popupStateSysOpen}
                popupState={popupState}
                setShowRename={setShowRename}
            >
                <List component="nav" aria-label="main mailbox folders">
                    {
                        showRename ? (
                            <ListItem key='000'>
                                <TextField
                                    autoFocus
                                    label={translate('pos.categories.enterName')}
                                    onKeyDown={onKeyDown}
                                    required
                                    onBlur={() => {
                                        validateFc('name', textValue.name)
                                    }}
                                    value={textValue.name}
                                    error={validate.name.message != "" && validate.name.isError}
                                    helperText={validate.name.message}
                                    fullWidth
                                    onChange={textOnChange('name')}
                                    variant="filled"
                                    InputProps={{
                                        className: classes2.input,
                                        classes: {
                                            underline: textValue.name !== '' ? classes2.underline : classes2.underlineNotValue,
                                            focused: classes2.focuses
                                        }
                                    }}
                                />
                            </ListItem>
                        ) : (
                                <ListItem button onClick={(e) => {
                                    setShowRename(true)
                                }}>
                                    <ListItemIcon className={classes2.iconPopover}>
                                        <EditOutlined />
                                    </ListItemIcon>
                                    <Typography className={classes2.titlePopover}>{translate('pos.categories.Rename')}</Typography>
                                </ListItem>
                            )
                    }
                    {
                        !isFolder ?
                            <ListItem button onClick={downloadFile}>
                                <ListItemIcon className={classes2.iconPopover}>
                                    <VerticalAlignBottomOutlined />
                                </ListItemIcon>
                                <Typography className={classes2.titlePopover}>{translate('pos.categories.Download')}</Typography>
                            </ListItem>
                            : <ListItem button onClick={downloadFolder}>
                                <ListItemIcon className={classes2.iconPopover}>
                                    <VerticalAlignBottomOutlined />
                                </ListItemIcon>
                                <Typography className={classes2.titlePopover}>{translate('pos.categories.Download')}</Typography>
                            </ListItem>
                    }
                    <ListItem button onClick={(event) => {
                        openSystemCategoryPopover(event, 'COPY');
                        dispatch(changeItemSelectedPopup(item));
                    }}>
                        <ListItemIcon className={classes2.iconPopover}>
                            <FileCopyOutlined />
                        </ListItemIcon>
                        <Typography className={classes2.titlePopover}>{translate('pos.categories.Copy')}</Typography>
                    </ListItem>
                    <ListItem button onClick={(event) => {
                        openSystemCategoryPopover(event, 'MOVE');
                        dispatch(changeItemSelectedPopup(item));
                    }}>
                        <ListItemIcon className={classes2.iconPopover}>
                            <SwapHorizontalCircleOutlined />
                        </ListItemIcon>
                        <Typography className={classes2.titlePopover}>{translate('pos.categories.Move')}</Typography>
                    </ListItem>

                    <ListItem button onClick={onDeleteItemClick}>
                        <ListItemIcon className={classes2.iconPopover}>
                            <DeleteOutline />
                        </ListItemIcon>
                        <Typography className={classes2.titlePopover}>{translate('pos.categories.Delete')}</Typography>
                    </ListItem>
                </List>
            </FilePopover>
            <CollapseImage expand={expand} item={item} />
        </List >
    );
}

CategoryItem.propTypes = {
    item: PropTypes.object.isRequired,
    classes: PropTypes.object.isRequired,
    getCategory: PropTypes.func.isRequired,
    onCheck: PropTypes.func.isRequired,
    setSnackbarMessage: PropTypes.func.isRequired,
};

export default CategoryItem;
